function initializeTextReviewSlider() {
  new Swiper(".text-review .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 5000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: { 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } },
  });
}
function decodeEscapedHTML(escaped) {
  var ta = document.createElement("textarea");
  ta.innerHTML = escaped;
  return ta.value || ta.innerHTML || escaped;
}
function elementOverflowsLines(originalEl, htmlString, lines) {
  var c = originalEl.cloneNode(false);
  c.style.position = "absolute";
  c.style.visibility = "hidden";
  c.style.pointerEvents = "none";
  c.style.height = "auto";
  c.style.maxHeight = "none";
  c.style.overflow = "visible";
  c.style.whiteSpace = "normal";
  c.style.boxSizing = "border-box";
  c.style.width = originalEl.getBoundingClientRect().width + "px";
  c.innerHTML = htmlString;
  document.body.appendChild(c);
  var cs = window.getComputedStyle(c);
  var lh = parseFloat(cs.lineHeight);
  if (isNaN(lh)) {
    lh = (parseFloat(cs.fontSize) || 16) * 1.2;
  }
  var over = c.scrollHeight > Math.ceil(lh * lines);
  document.body.removeChild(c);
  return over;
}
function truncateToLines(el, lines) {
  if (!el) return;
  var escaped = el.getAttribute("data-full-review") || "";
  var fullHTML = decodeEscapedHTML(escaped);
  if (!fullHTML) fullHTML = el.innerText || el.textContent || "";
  var card = el.closest(".text-review__item");
  var need = elementOverflowsLines(el, fullHTML, lines);
  if (!need) {
    el.innerHTML = fullHTML;
    if (card) {
      card.classList.remove("has-readmore");
      card.removeAttribute("tabindex");
      card.removeAttribute("role");
      card.removeAttribute("data-modal-init");
    }
    return;
  }
  var temp = document.createElement("div");
  temp.style.position = "absolute";
  temp.style.visibility = "hidden";
  temp.style.pointerEvents = "none";
  temp.style.height = "auto";
  temp.style.maxHeight = "none";
  temp.style.overflow = "visible";
  temp.style.whiteSpace = "normal";
  temp.style.boxSizing = "border-box";
  temp.style.width = el.getBoundingClientRect().width + "px";
  temp.innerHTML = fullHTML;
  document.body.appendChild(temp);
  var fullText = (temp.textContent || temp.innerText || "").replace(
    /\u00A0/g,
    " "
  );
  document.body.removeChild(temp);
  var start = 0,
    end = fullText.length,
    best = 0;
  var measurer = el.cloneNode(false);
  measurer.style.position = "absolute";
  measurer.style.visibility = "hidden";
  measurer.style.pointerEvents = "none";
  measurer.style.height = "auto";
  measurer.style.maxHeight = "none";
  measurer.style.overflow = "visible";
  measurer.style.whiteSpace = "normal";
  measurer.style.boxSizing = "border-box";
  measurer.style.width = el.getBoundingClientRect().width + "px";
  document.body.appendChild(measurer);
  var cs = window.getComputedStyle(measurer);
  var lh = parseFloat(cs.lineHeight);
  if (isNaN(lh)) {
    lh = (parseFloat(cs.fontSize) || 16) * 1.2;
  }
  var maxHeight = Math.ceil(lh * lines);
  while (start <= end) {
    var mid = Math.floor((start + end) / 2);
    measurer.textContent = fullText.slice(0, mid) + "…";
    if (measurer.scrollHeight <= maxHeight) {
      best = mid;
      start = mid + 1;
    } else {
      end = mid - 1;
    }
  }
  document.body.removeChild(measurer);
  var truncated = fullText.slice(0, best).replace(/\s+\S*$/, "");
  var words = truncated.trim().split(/\s+/);
  if (words.length > 2) {
    words = words.slice(0, words.length - 2);
  } else if (words.length > 1) {
    words = words.slice(0, Math.max(0, words.length - 1));
  }
  var finalText = words.join(" ").trim();
  if (finalText.length > 0) {
    finalText = finalText + "\u2026";
  } else {
    finalText =
      fullText.slice(0, Math.max(10, Math.floor(best / 2))) + "\u2026";
  }
  el.textContent = finalText;
  var readmore = document.createElement("span");
  readmore.className = "text-review__readmore";
  readmore.textContent = " read more";
  el.appendChild(readmore);
  if (card) {
    card.classList.add("has-readmore");
    if (!card.hasAttribute("data-modal-init")) {
      card.setAttribute("tabindex", "0");
      card.setAttribute("role", "button");
    }
  }
}
function openReviewModal(fullHTML, author) {
  if (document.querySelector(".text-review__modal")) return;
  var sectionEl = document.querySelector(".text-review");
  var starUrl = sectionEl ? sectionEl.getAttribute("data-star-url") : "";
  var verifiedUrl = sectionEl
    ? sectionEl.getAttribute("data-verified-url")
    : "";
  var overlay = document.createElement("div");
  overlay.className = "text-review__modal";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  var box = document.createElement("div");
  box.className = "text-review__modal-box";
  var closeBtn = document.createElement("button");
  closeBtn.className = "text-review__modal-close";
  closeBtn.innerHTML = "✕";
  closeBtn.setAttribute("aria-label", "Close");
  closeBtn.addEventListener("click", closeModal);
  var header = document.createElement("div");
  header.className = "text-review__modal-header";
  if (starUrl) {
    var starImg = document.createElement("img");
    starImg.src = starUrl;
    starImg.alt = "Trustpilot rating";
    starImg.loading = "lazy";
    header.appendChild(starImg);
  }
  var verifiedWrap = document.createElement("span");
  verifiedWrap.className = "text-review__modal-verified";
  if (verifiedUrl) {
    var checkImg = document.createElement("img");
    checkImg.src = verifiedUrl;
    checkImg.alt = "Verified";
    checkImg.loading = "lazy";
    verifiedWrap.appendChild(checkImg);
  }
  var verifiedText = document.createElement("span");
  verifiedText.textContent = "Verified";
  verifiedWrap.appendChild(verifiedText);
  header.appendChild(verifiedWrap);
  var content = document.createElement("div");
  content.className = "text-review__modal-content";
  content.innerHTML = fullHTML;
  var authorEl = document.createElement("div");
  authorEl.className = "text-review__modal-author";
  authorEl.textContent = author;
  box.appendChild(closeBtn);
  box.appendChild(header);
  box.appendChild(content);
  box.appendChild(authorEl);
  overlay.appendChild(box);
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) closeModal();
  });
  function escHandler(e) {
    if (e.key === "Escape") closeModal();
  }
  function closeModal() {
    document.removeEventListener("keydown", escHandler);
    var o = document.querySelector(".text-review__modal");
    if (o && o.parentNode) o.parentNode.removeChild(o);
  }
  document.addEventListener("keydown", escHandler);
  document.body.appendChild(overlay);
}
function initReviewTruncation() {
  var els = Array.from(document.querySelectorAll(".text-review__content"));
  if (!els.length) return;
  function runAll() {
    var prevCards = document.querySelectorAll(
      ".text-review__item.has-readmore"
    );
    prevCards.forEach(function (c) {
      c.classList.remove("has-readmore");
      c.removeAttribute("tabindex");
      c.removeAttribute("role");
      c.removeAttribute("data-modal-init");
    });
    els.forEach(function (el) {
      var escaped = el.getAttribute("data-full-review") || "";
      var full = decodeEscapedHTML(escaped);
      el.innerHTML = full;
      truncateToLines(el, 4);
    });
    initCardModalTriggers();
  }
  window.requestAnimationFrame(function () {
    setTimeout(runAll, 60);
  });
  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      runAll();
    }, 200);
  });
}
function initCardModalTriggers() {
  var items = Array.from(
    document.querySelectorAll(".text-review__item.has-readmore")
  );
  if (!items.length) return;
  items.forEach(function (item) {
    if (item.getAttribute("data-modal-init") === "1") return;
    item.setAttribute("data-modal-init", "1");
    if (!item.hasAttribute("tabindex")) item.setAttribute("tabindex", "0");
    if (!item.hasAttribute("role")) item.setAttribute("role", "button");
    var startX = 0,
      startY = 0,
      moved = false;
    item.addEventListener(
      "pointerdown",
      function (ev) {
        moved = false;
        startX = ev.clientX || 0;
        startY = ev.clientY || 0;
      },
      { passive: true }
    );
    item.addEventListener(
      "pointermove",
      function (ev) {
        if (typeof startX !== "number") return;
        var dx = Math.abs((ev.clientX || 0) - startX);
        var dy = Math.abs((ev.clientY || 0) - startY);
        if (dx > 8 || dy > 8) moved = true;
      },
      { passive: true }
    );
    item.addEventListener("click", function (e) {
      if (moved) return;
      var interactive = e.target.closest("a, button, input, textarea, select");
      if (interactive && interactive !== item) return;
      var contentEl = item.querySelector(".text-review__content");
      if (!contentEl) return;
      var escaped = contentEl.getAttribute("data-full-review") || "";
      var fullHTML = decodeEscapedHTML(escaped);
      if (!fullHTML)
        fullHTML = contentEl.innerHTML || contentEl.textContent || "";
      var author =
        contentEl.getAttribute("data-author") ||
        (item.querySelector(".text-review__author")
          ? item.querySelector(".text-review__author").textContent
          : "");
      openReviewModal(fullHTML, author);
    });
    item.addEventListener("keydown", function (ev) {
      if (ev.key === "Enter" || ev.key === " ") {
        ev.preventDefault();
        var contentEl = item.querySelector(".text-review__content");
        if (!contentEl) return;
        var escaped = contentEl.getAttribute("data-full-review") || "";
        var fullHTML = decodeEscapedHTML(escaped);
        if (!fullHTML)
          fullHTML = contentEl.innerHTML || contentEl.textContent || "";
        var author =
          contentEl.getAttribute("data-author") ||
          (item.querySelector(".text-review__author")
            ? item.querySelector(".text-review__author").textContent
            : "");
        openReviewModal(fullHTML, author);
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {
  initializeTextReviewSlider();
  initReviewTruncation();
  window.requestAnimationFrame(function () {
    setTimeout(function () {
      initCardModalTriggers();
    }, 80);
  });
});
